import axios from "axios";

// Cookie-only auth plumbing for raw-axios call sites:
// - harvests the xsrf synchronizer token from any response that carries it
//   (login, /auth/me), keeps it in memory (never localStorage);
// - injects `x-xsrf-token` on mutating requests (required by csrfProtect).
let xsrf = null;

export const setXsrf = (t) => {
  xsrf = typeof t === "string" && t.length === 64 ? t : null;
};

export const getXsrf = () => xsrf;

axios.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method === "get" || method === "head" || method === "options") {
    return config;
  }
  if (xsrf) {
    config.headers = config.headers || {};
    config.headers["x-xsrf-token"] = xsrf;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    const t = response && response.data && response.data.xsrf;
    if (typeof t === "string" && t.length === 64) {
      xsrf = t;
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default { setXsrf, getXsrf };
